import { render, staticRenderFns } from "./OptionSelectDesktop.vue?vue&type=template&id=31e2fc9a&"
import script from "./OptionSelectDesktop.vue?vue&type=script&lang=js&"
export * from "./OptionSelectDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports